import Vue from 'vue'
import Router from 'vue-router'
import Admin from './components/core/Admin'

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    { path: '/login', name: 'login', component: () => import('./page/login/login') },
    { path: '/register', name: 'register', component: () => import('./page/login/register') },
    { path: '/forget', name: 'forget', component: () => import('./page/login/forget') },
    {
      path: '/', component: Admin, children: [
        {
          path: '/',  // 默认进入路由
          redirect: '/home'   //重定向
        },
        { path: '/upload', name: 'upload', component: () => import('./page/upload/upload'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        //消息
        { path: '/info/intro', name: 'info_intro', component: () => import('./page/info/intro'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/info/arrange', name: 'info_arrange', component: () => import('./page/info/arrange'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/info/notice', name: 'info_notice', component: () => import('./page/info/notice'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/info/org', name: 'info_org', component: () => import('./page/info/org'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/info/contact', name: 'info_contact', component: () => import('./page/info/contact'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/info/team_show', name: 'info_team_show', component: () => import('./page/info/team_show'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/info/news', name: 'info_news', component: () => import('./page/info/news'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        //个人中心
        { path: '/personal/create_team', name: 'personal_create_team', component: () => import('./page/personal/create_team'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/personal/audit', name: 'personal_audit', component: () => import('./page/personal/audit'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/personal/job', name: 'personal_job', component: () => import('./page/personal/job'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        // 首页
        { path: '/home', name: 'home', component: () => import('./page/home/home'),meta:{title:'第七届中国大学生公共关系策划大赛'}},
        // 详情
        { path: '/details', name: 'details', component: () => import('./page/home/details'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/works', name: 'works', component: () => import('./page/home/works'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
        { path: '/home/company_details', name: 'company_details', component: () => import('./page/home/company_details'),meta:{title:'第七届中国大学生公共关系策划大赛'} },
      ]
    },
  ]
})
